import { Popup as AntdMobilePopup } from "antd-mobile";
import { BasePopupProps } from "./Popup.types";
import "./Popup.scss";

export const Popup: React.FC<BasePopupProps> = ({
  children,
  visible = false,
  onClose,
  placement = "bottom",
  mask = true,
  maskClosable = true,
  destroyOnClose = false,
  className = "",
  testId,
  ...props
}) => {
  const popupClass = ["popup", `popup--${placement}`, className]
    .filter(Boolean)
    .join(" ");

  // Convert placement to supported position values
  const position =
    placement === "topLeft" || placement === "topRight"
      ? "top"
      : placement === "bottomLeft" || placement === "bottomRight"
        ? "bottom"
        : placement;

  return (
    <AntdMobilePopup
      className={popupClass}
      visible={visible}
      onClose={onClose}
      position={position as "top" | "bottom" | "left" | "right"}
      mask={mask}
      closeOnSwipe={maskClosable}
      destroyOnClose={destroyOnClose}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdMobilePopup>
  );
};

export default Popup;
